import React from 'react'

const IgRightArrow = () => (
  <svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.77699 8.9082L5.01136 8.15252L8.16335 5.00053H0V3.90678H8.16335L5.01136 0.764737L5.77699 -0.000887632L10.2315 4.45366L5.77699 8.9082Z" fill="#666666"/>
</svg>

)

export default IgRightArrow
